import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  container: {
    height: '100%',
  },
  move: {
    minWidth: 'auto',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
  },
  moveResponse: {
    paddingLeft: theme.spacing(0.5),
  },
});

class LinearHistory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { classes, theme } = this.props;

    const { history, onMoveClick, lastMoveId, startMoveNumber = 1 } = this.props;

    const highlightStyle = {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
    }
    const normalStyle = {
      backgroundColor: 'inherit'
    }

    const startWithBlack = history?.length && history[0].color === 'b';

    return (
      <div className={classes.container}>
        { history && history.length && history.map((move, i) => {
          const isNumbered = (i % 2 === 0 && !startWithBlack) || (startWithBlack && (i === 0 || i % 2 === 1));
          const fullMoveNumber = startWithBlack ? (i === 0 ? 0 : (i+1) / 2) : (i / 2);
          return (
            <span key={`move-${i}`}>
              <Button
                className={isNumbered ? classes.move : [classes.move, classes.moveResponse].join(' ')}
                size="small"
                variant="text"
                style={{ textTransform: 'none', ...(i === lastMoveId ? highlightStyle : normalStyle) }}
                aria-current={i === lastMoveId ? 'step' : undefined}
                onClick={() => { onMoveClick(i) }}
              >
                {isNumbered && `${fullMoveNumber+startMoveNumber}${startWithBlack && i === 0 ? '...' : '.' }`}
                {move.san}
              </Button>
            </span>
          )
        })}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LinearHistory);
